import { useSelector } from 'react-redux';

const useFinPlandate = () => {
    const { financialPlan } = useSelector((state) => state.accountReducer);

    const planYear = financialPlan?.year ?? null;
    const stages = Array.isArray(financialPlan?.stages) ? [...financialPlan.stages] : [];
    const currentYear = new Date().getFullYear();

    if (!planYear) {
        return {
            stageStartDate: null,
            stageEndDate: null,
        };
    }

    if (!stages.length) {
        const start = currentYear;
        const end = planYear;

        if (start > end) {
            return {
                stageStartDate: null,
                stageEndDate: null,
            };
        }

        return {
            stageStartDate: start,
            stageEndDate: end,
        };
    }

    stages.sort((a, b) => a.start_year - b.start_year);

    // Дыра до первого этапа
    const first = stages[0];
    if (first.start_year > currentYear) {
        const start = currentYear;
        const end = first.start_year - 1;
        if (start <= end) {
            return {
                stageStartDate: start,
                stageEndDate: end,
            };
        }
    }

    // Первая дыра между соседними этапами
    for (let i = 0; i < stages.length - 1; i++) {
        const a = stages[i];
        const b = stages[i + 1];
        const candidateStart = a.end_year + 1;
        const endBetween = b.start_year - 1;
        if (candidateStart <= endBetween) {
            const start = Math.max(candidateStart, currentYear);
            const end = endBetween;
            if (start <= end) {
                return {
                    stageStartDate: start,
                    stageEndDate: end,
                };
            }
        }
    }

    // Добавление после последнего этапа
    const last = stages[stages.length - 1];
    {
        const start = last.end_year + 1;
        const end = planYear;
        if (start <= end) {
            return {
                stageStartDate: start,
                stageEndDate: end,
            };
        }
    }

    return {
        stageStartDate: null,
        stageEndDate: null,
    };
};

export default useFinPlandate;